module.exports = __webpack_public_path__ + "img/17.b5256ebe.jpeg";